import { RoutesInterface } from '@navigation/authRoutes';
import collaboratorRoutes from '@navigation/collaboratorRoutes';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PersonIcon from '@mui/icons-material/Person';
import StoreIcon from '@mui/icons-material/Store';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import DashboardScreen from '@screens/Dashboard/DashboardScreen';
import ListUsersScreen from '@screens/Users/ListUsers';
import ListBranchOfficesScreen from '@screens/BranchOffices/ListBranchOfficesScreen';
import RewardsPromotionsScreen from '@screens/Rewards/RewardsPromotionsScreen';

// ============================================================================
// RUTAS DEL ADMIN DE SUCURSAL (plan de Gastos F6, §4.2): "que hagan todo lo que yo
// puedo hacer como admin, pero a nivel sucursal nomás". Todo lo del gerente (POS,
// pedidos, informe con Gastos y Estado de Resultados, clientes, inventario, mesas)
// más sus pantallas propias, las MISMAS del admin acotadas por `Capabilities`:
// - Dashboard: sin "Todas las sucursales"; elimina pedidos de las suyas (2026-09-30).
// - Usuarios: los de sus sucursales; alta de colaborador, gerente y admin de
//   sucursal; desactivar o eliminar (2026-09-30), con la confirmación de la consecuencia.
// - Mi sucursal: editar las suyas, sin número, CEDIS ni inventario.
// - Promociones: códigos de sus sucursales (los de "Todas", solo lectura); sin
//   Recompensas (es global).
// El acceso real lo deciden los servicios (`can`), no esta lista.
// ============================================================================

const branchAdminRoutes: RoutesInterface[] = [
    ...collaboratorRoutes,
    {
        path: 'dashboard',
        name: 'Dashboard',
        element: DashboardScreen,
        icon: DashboardIcon
    },
    {
        path: 'myBranch',
        name: 'Mi sucursal',
        element: ListBranchOfficesScreen,
        icon: StoreIcon
    },
    {
        path: 'users',
        name: 'Usuarios',
        element: ListUsersScreen,
        icon: PersonIcon
    },
    {
        path: 'customers/promotionalCodes',
        name: 'Códigos promocionales',
        element: RewardsPromotionsScreen,
        icon: LoyaltyIcon
    }
];

export default branchAdminRoutes;
